<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Thống kê Merchant Nextlend</h1>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <DateRangePicker
              placeholder="Thời gian"
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label style="min-width: 13.5em" class="text-center pt-1">
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model="search.textSearch"
              class="form-control f12 hc-37"
              placeholder="Từ khóa"
            />
          </div>

          <div class="form-group">
            <Select2
              placeholder="Vùng"
              v-model="search.regionId"
              :options="dataRegion"
              @change="queryProvince($event)"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.cityCode"
              :options="dataProvince"
              placeholder="Tỉnh/Thành phố"
            ></Select2>
          </div>
          <div class="form-group form-group-action">
            <button
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
              @click="submitForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              type="button"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="removeForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
            <button
              @click="exportExcel"
              type="button"
              class="btn btn-info hc-37 mr-2 pt-2 file-input"
              data-toggle="tooltip"
              data-placement="top"
              title="Xuất Excel"
            >
              <i class="bx bx-download"></i>
              <span class="ml-1">&nbsp;</span>Xuất Excel
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div
            class="table-responsive"
            v-if="dataPermission && dataPermission.includes('CNPS_CALENDAR_AFS_LIST_ON_WEB')"
          >
            <div class="box-header">
              Tổng số Sales:<strong class="text-primary">{{ statistical.totalSale }}</strong>
              &nbsp;&nbsp;| &nbsp;&nbsp; Tổng số Merchant :<strong class="text-primary">{{
                statistical.totalMc
              }}</strong>
              &nbsp;&nbsp;| &nbsp;&nbsp; Merchant giải ngân :<strong class="text-primary">{{
                statistical.totalDisbursed
              }}</strong>
              &nbsp;&nbsp;| &nbsp;&nbsp;
            </div>
            <table class="table table-hover table-bordered" id="tableScroll">
              <thead class="thead-light">
                <tr>
                  <th scope="col" width="50">STT</th>
                  <th scope="col" width="">Sale chăm sóc</th>
                  <th scope="col" width="">Tiềm năng</th>
                  <th scope="col" width="">Đang tiếp cận</th>
                  <th scope="col" width="">Chờ duyệt</th>
                  <th scope="col" width="">Đã duyệt</th>
                  <th scope="col" width="">Đã giải ngân</th>
                  <th scope="col" width="">Từ chối</th>
                  <th scope="col" width="">Hồ sơ sai</th>
                  <th scope="col" width="">Thao tác</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="loading">
                  <td colspan="11" align="center">
                    <i class="bx bx-loader-circle bx-spin bx-rotate-90 f30"></i>
                  </td>
                </tr>
                <tr class="table-row" v-for="(item, index) in dataMC" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>
                    <div>{{ item.activeSaleName }}</div>
                    <div>#Sale: {{ item.companyCode }}</div>
                  </td>
                  <td>
                    {{ item.potential }}
                  </td>
                  <td>
                    {{ item.draft }}
                  </td>
                  <td>
                    {{ item.sttNew }}
                  </td>
                  <td>
                    {{ item.sttActived }}
                  </td>
                  <td>
                    {{ item.sttDisbursed }}
                  </td>
                  <td>
                    {{ item.sttRejected }}
                  </td>
                  <td>
                    {{ item.sttInvalidProfile }}
                  </td>
                  <td>
                    <a class="dropdown-item" @click="mcNextlendDetail(item)">Chi tiết</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination-bottom">
      <b-pagination
        v-model="search.page"
        :total-rows="pagination.total"
        :per-page="search.limit"
        class="fl-right mr-2"
      ></b-pagination>
    </div>
  </div>
</template>
<script>
  import { MerchantService } from '@/services/merchant.service'
  import { StaffService } from '@/services/staff.service'
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  export default {
    components: {
      DateRangePicker,
    },
    mixins: [prepareQueryParamsMixin],
    data() {
      return {
        search: {
          page: 1,
          limit: 50,
        },
        pagination: {
          total: 0,
        },
        dataMC: [],
        statistical: {},
        localeData: {
          direction: 'ltr',
          format: 'dd/mm/yyyy',
          separator: ' - ',
          applyLabel: 'Áp dụng',
          cancelLabel: 'Hủy bỏ',
          weekLabel: 'W',
          daysOfWeek: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
          monthNames: [
            'Tháng 1',
            'Tháng 2',
            'Tháng 3',
            'Tháng 4',
            'Tháng 5',
            'Tháng 6',
            'Tháng 7',
            'Tháng 8',
            'Tháng 9',
            'Tháng 10',
            'Tháng 11',
            'Tháng 12',
          ],
          firstDay: 0,
        },
        dateRange: {
          startDate: null,
          endDate: null,
        },
        dataStaff: [],
        dataRegion: [],
        dataProvince: [],
        dataResult: [
          { id: 'SUCCESS', text: 'Thành công' },
          { id: 'FAILED', text: 'Thất bại' },
          { id: 'OTHERS', text: 'Khác' },
        ],
        loading: true,
      }
    },
    mounted() {
      this.fetchData()
      this.getRegions()
    },
    watch: {
      'search.limit': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.search.limit,
          page: this.search.page,
        })
      },
    },
    filters: {
      // lấy ngày, giờ
      formatTime(ms) {
        return (
          new Date(ms).getHours() +
          ':' +
          new Date(ms).getMinutes() +
          ', ' +
          new Date(ms).getDate() +
          '/' +
          (new Date(ms).getMonth() + 1) +
          '/' +
          new Date(ms).getFullYear()
        )
      },
      formatDatePicker(date) {
        if (!date) return
        return moment(date).format('DD/MM/YYYY')
      },
    },
    methods: {
      // chuyển trang chi tiết
      mcNextlendDetail(item) {
        localStorage.setItem('startDate', JSON.stringify(this.dateRange.startDate))
        localStorage.setItem('endDate', JSON.stringify(this.dateRange.endDate))
        console.log(this.dateRange)
        this.$router.push({ path: `/list-mc-nextlend/detail/${item.activeSaleEmail}` })
      },
      // xuất file excel
      async exportExcel() {
        try {
          this.loading = true
          await MerchantService.exportMerchantNextlend(this.search)
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      // define ngày trên lịch
      transformDate() {
        this.search.startDate = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.endDate = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
      },
      // Lọc
      async submitForm(event) {
        event.preventDefault()
        this.pagination.page = 1
        this.fetchData()
      },
      // Bỏ lọc
      async removeForm() {
        this.search = {
          limit: 50,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        await this.fetchData()
      },
      // lấy vùng
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.success) {
          this.dataRegion.push({ id: 0, text: 'Tất cả' })
          data.data.map(e => {
            this.dataRegion.push({ id: e.id, text: e.name })
          })
        }
      },
      // lấy tỉnh, tp
      async queryProvince(e) {
        if (this.search.regionId === '0') {
          this.dataProvince = []
          delete this.search.cityCode
        }
        try {
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            this.dataProvince = data.data.map(e => {
              return { id: e.code, text: e.name }
            })
          }
        } catch (error) {}
      },
      async fetchData() {
        try {
          if (this.search.regionId === '0') delete this.search.regionId
          // this.search.userId = this.dataUser.userId
          const data = await MerchantService.nextlendMCReport(this.search)
          if (data.success) {
            this.dataMC = data.data.rows
            this.pagination.total = data.meta.pagination.total ? data.meta.pagination.total : 0
            this.statistical = {
              totalSale: data.data.totalSale,
              totalMc: data.data.totalMc,
              totalDisbursed: data.data.totalDisbursed,
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>
<style scoped>
  .wrapper-cancel {
    margin-top: 30px;
    font-size: 24px;
    text-align: center;
    padding: 0 15px;
  }
</style>
